var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeArrowFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 60,
    height: 60,
    transform: "rotate(-90 0 60)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_82_3",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_82_3",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpklEQVR4nO3csW/TQBTH8QgJCbHABBIMDLDCwgRLpOC7hlLfC4husCH+BcYysjIiNv4A+AdggQ2hMjOgtMmdW2BCAjGACEoaCxZQSny+5/r7kd6SyU8/3zl+cdzpAAAAAAAAAAAAAAAAAJgT43MxfseZUMhKcbv8HIm4aRA2TMpy1j/udodHCCQR+SOM36GEt7kdnSMUJYHItIz/7IxfJxQtgdhp+Z9i/cO7F98cJhgVgYRytby+sVqcIRQtgdjZavk0MMESippAwmwLc8Y/2NiYHCIYFYGEsl7kvd2ThKInkIkzYSzWXyYUJYHI3hb2XWy4RyhqAilXi38m3eHxKo+rtaSCQOZ39+/y/vhC6n4aTyoKZF7fJAt3UvfUaFJtIOUW9mRtLRxN3VsjSYRA5lsYA0pNgcyKAaWyQFIOKCUbr+7dLMVusJnlrH91rTc6XVsghBEWCeWDZP5KLYGkPgOlMVXTgDJ9o6FpFXdAqaDBSdMq6oAydXPS2Io0oEzfWGh0VT6gTN2QHICqdECZuhk5KGX814EprhKIVbRSjN8iEKsqkCGBWC3lv+S26BOI1XFRl2x0nou6TR+GWP90PXt/rJIw+JYVlgmCG0PRskWZMBqs+EuVrQpWSFjmevH8utk50Ykl9dkmDSln/A8x4X708Ts/UIUFAvG7uRn3OnWY3u5P98TUZ6AoLWf8S5dtn6oljCaT6GHwL6x9if8Y0Pjm/o6o5SReIJuD/vbZ1P01jsS5XvAo6f+qOAwetl6WysFgm4nGwWCbyXJB8Jc2LYG4mIPBNhONg8E2E42DwTaTxcP4yKs1lATiGAzWR/79LYrXM9VN/hYGg0FVgWwyGNTzEsxHvAQz8WtinfFbYoPPTXEr5bEAAAAAAAAAAAAAAAAAnah+Af+1iuc0WJDWAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeArrowFilled);
export default __webpack_public_path__ + "static/media/likeArrowFilled.b35420ce5c46255cdb7fc7b3de2e37d4.svg";
export { ForwardRef as ReactComponent };